import {
  Injectable
}      from '@angular/core';





import {
  HttpClient,
  HttpParams
} from '@angular/common/http';

@Injectable()
export class GeocoderService {

  constructor(private http: HttpClient) {
  }

  public geocode(address: string, cb: any): void {
    const params = new HttpParams()
      .set('address', address)
      .set('key', 'AIzaSyD3OnF-PVU0Dm2dhlWgiALUEe7L2nXaddY');

    this.http.get('https://maps.googleapis.com/maps/api/geocode/json', { params })
      .subscribe((resp: any) => {
        cb(null, resp);
      }, (error) => {
        cb(error);
      });
  }
}
